import React from "react";

import {
 
  Row,
  Col
 
} from "reactstrap";


import ContentWrapper from  '../../components/Layout/ContentWrapper'
import bridge from "../../assets/images/itoagent/bridge.png";
import BreadCrumbs from '../../layouts/breadcrumbs/BreadCrumbs';

const AboutUs = (props) => {

  return (

         
       <React.Fragment>
          <ContentWrapper colspan='7'>
              <BreadCrumbs />
              <Row className="justify-content-center">
                  <Col lg={12} className="text-center mt-0 pt-0">
                     <img src={bridge} alt="" className="img-fluid" />
                  </Col>
              </Row>

             <Row>
                  <Col lg={12} className="text-center mt-3 pt-0">

<h5>Who we are</h5>
<p>
We are a Sydney-based startup with an in-house team of experts, designers, and great problem-solvers. Our mentors and developers, including former Google and NASA engineeers, bring invaluable experience to the team.
</p>

<h5>Our mission</h5>
<p>
Our mission is to build a unified communicaiton platform to help our customers to connect their end users through our services like live chat, ticketing, task management and team messaging. We have exciting pipelines of new releases on the way!
</p>


<h5>Our commitment</h5>
<p>
At itoagent, Our customers are our top priority.
We are a 100% open-source, in-house development team. Besides developing our services, we create custom libraries instead of using proprietary ones to ensure cohesion, reduced dependency, flexibility, and reusability.
</p>


<h5>Write us</h5>
<p>
Please Share your thoughts with us at admin@itoagent.com. We typically reply within 1-2 business days.
We look forward to hearing from you!
</p>


                  </Col>
                  </Row>

          </ContentWrapper>
      </React.Fragment>
  )
};

export default AboutUs;
